import { useRouter } from "@src/lib/router";
import React from "react";
import { useSelector } from "react-redux";
import {
  handleStartDownloadContent,
  handleStopDownloadContent,
} from "../../../helpers/handleDownloadContent";
import { CONTENT_DOWNLOAD_STATUS } from "../../../store/constants";
import DownloadCompletedIcon from "./DownloadCompletedIcon";
import DownloadIcon from "./DownloadIcon";
import DownloadProgressIcon from "./DownloadProgressIcon";
import { getOrgId } from "@src/cosmosTracking/helper";

const ContentDownloader = ({
  content,
  handleGetOfflineDownloadList,
  getOfflineDownloadedItemProgress,
  getOfflineDownloadedItemState,
  handleSetCheckProgressInterval,
  handleClearCheckProgressInterval,
}) => {
  // NEXTJS ROUTER
  const router = useRouter();

  let deviceType = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    ? "IOS"
    : "ANDROID";

  // FETCHING COURSE NAME FROM REDUX
  const courseName = useSelector(
    (state: any) => state?.overviewReducer?.overViewDetails?.course?.details?.name
  );

  // FUNCTION TO CHECK IF DOWNLOAD ICON HAS TO BE SHOWN
  const showDownloadIcon = (content) => {
    if (isNaN(getOfflineDownloadedItemState(content))) return true;
    switch (getOfflineDownloadedItemState(content)) {
      case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_PAUSE:
      case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_FAILED:
      case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_REMOVE:
      case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_CANCEL:
      case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_UNKNOWN: {
        return true;
      }
    }
    return false;
  };

  const orgId = getOrgId();
  const checkIfDrmVideoInIoS = deviceType === "IOS" && content?.drmProtected === 1 && ![379965, 170, 573212].includes(orgId);

  // HANDLE START DOWNLOADING CLICKED
  const handleStartDownloadClicked = (content) => {
    handleStartDownloadContent({
      ...content,
      courseId: +router?.query?.courseId,
      originalCourseId: parseInt(router?.query?.originalCourseId as string),
      courseName: courseName,
    });
    handleSetCheckProgressInterval?.();
  };

  // HANDLE STOP DOWNLOADING CLICKED
  const handleStopDownloadClicked = (content) => {
    handleStopDownloadContent({
      ...content,
      courseId: +router?.query?.courseId,
      courseName: courseName,
      originalCourseId: parseInt(router?.query?.originalCourseId as string),
    });
    handleGetOfflineDownloadList?.();
  };

  return (
    <React.Fragment>
      {/*<p>{`P - ${getOfflineDownloadedItemProgress(content?.url) || 0} ** S -${
        getOfflineDownloadedItemState(content?.url) || 0
      }`}</p>*/}
      {(getOfflineDownloadedItemState(content) ===
        CONTENT_DOWNLOAD_STATUS.DOWNLOAD_IN_PROGRESS ||
        getOfflineDownloadedItemState(content) ===
          CONTENT_DOWNLOAD_STATUS.DOWNLOAD_QUEUED) && (
        <DownloadProgressIcon
          onClick={() => handleStopDownloadClicked(content)}
          progress={getOfflineDownloadedItemProgress(content)}
        />
      )}
      {/*getOfflineDownloadedItemState(content?.url) ===
          CONTENT_DOWNLOAD_STATUS.DOWNLOAD_QUEUED && <p>Q</p>*/}
      {(getOfflineDownloadedItemState(content) ===
        CONTENT_DOWNLOAD_STATUS.DOWNLOAD_SUCCESS ||
        getOfflineDownloadedItemState(content) ===
          CONTENT_DOWNLOAD_STATUS.DOWNLOAD_ALREADY_DOWNLOADED) && (
        <DownloadCompletedIcon />
      )}

      {showDownloadIcon(content) && !content?.isAudio ? (
        checkIfDrmVideoInIoS ? null : <DownloadIcon onClick={() => handleStartDownloadClicked(content)} />
      ) : null}
    </React.Fragment>
  );
};

export default ContentDownloader;
